import { debounce } from 'lodash';

class Accordion {
	stateClasses = {
		open: 'accordion--open',
	};
	isOpen = false;

	constructor($el) {
		this.$el = $el;
		this.$trigger = $el.find('[data-accordion="trigger"]');
		this.$content = $el.find('[data-accordion="content"]');
		this.height = this.$content[0].scrollHeight;

		this.init();
	}

	init = () => {
		this.$trigger.on('click', this.clickHandler);
		this.getHeight();
		$(window).on('resize', debounce(this.getHeight, 250));
	};

	clickHandler = () => {
		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	};

	getHeight = () => {
		this.height = this.$content[0].scrollHeight;
	};

	open = () => {
		this.$el.addClass(this.stateClasses.open);
		this.$content.css('max-height', `${this.height}px`);
		this.$content.one('transitionend', this.transitionEndHandler);
		this.isOpen = true;
	};

	close = () => {
		this.$el.removeClass(this.stateClasses.open);
		this.$content.css('max-height', `${this.height}px`);
		window.requestAnimationFrame(() => {
			this.$content.css('max-height', 0);
		});
		this.isOpen = false;
	};

	transitionEndHandler = () => {
		if (this.isOpen) {
			this.$content.css('max-height', 'none');
		} else {
			this.$content.css('max-height', 0);
		}
	};
}

export default Accordion;
